import React from 'react';
import { convertTwoDecimalPoint, calculateStripeCharges, getLoginParent, getMurchantPayChargesStatus, _addNotificationError, getPaymentGatewayCharges, calculateUPayCharges, getPaymentGateway, calculatePayMayaCharges } from '../../../server/util'
import StripeEventCheckOut from './stripeEventCheckout';
import PaymentModule from '../../Misc/PaymentModule';
import { paymentGatewayOptions, stripeInfo } from '../../../server/constants';
import { postWithHeaders } from '../../../server/actions';
class CheckoutList extends React.Component {
    calculateTotals = (list) => {
        let total = 0.00
        list.forEach(item => {
            total = total + parseFloat(convertTwoDecimalPoint(item.amount));
        })
        return total;
    }
    calculateFinalCharges = () => {
        let totalAmount = 0.00
        Object.keys(this.props.checkOutData).forEach(eventId => {
            this.props.checkOutData[eventId].studentList.forEach(student => {
                totalAmount = totalAmount + parseFloat(convertTwoDecimalPoint(student.amount))
            })
        })
        return totalAmount
    }
    validatePayment = () => {
        return this.calculateFinalCharges() > 0 ? true : false
    }
    showHideLoading = (isShow) => {
        this.setState({ loading: isShow })
    }
    calculateTotalFee = (reqObject) => {
        let requestObject = {
            "transactionType": "Event",
            "purchaseItemType": "Event",
            "paymentType": "Online",
            "transactionDescription": "Buy events",
            //"appFeeAmount":stripeInfo(this.props.schoolObject.schoolId).application_free,
            "studentWiseTransactions": [],
            "parentUserEmails": sessionStorage.getItem('loggedInUserInfo'),
            "mealSchoolId": this.props.schoolObject.schoolId
        };
        let totalAmount = 0.00;
        let studentWiseTransactions = [];
        Object.keys(reqObject).forEach(eventId => {
            reqObject[eventId].studentList.forEach(student => {
                if (parseFloat(convertTwoDecimalPoint(student.amount)) > 0) {
                    totalAmount = totalAmount + parseFloat(convertTwoDecimalPoint(student.amount))
                    studentWiseTransactions.push({
                        studentRecId: student.userId,
                        transactionAmount: student.amount,
                        eventInfo: {
                            recId: eventId
                        }
                    })
                }
            })
        });
        requestObject.studentWiseTransactions = studentWiseTransactions;
        requestObject.totalTransactionAmount = totalAmount;
        requestObject.balAmount = totalAmount;
        requestObject.transactionFees = calculateStripeCharges(totalAmount);
        return requestObject;
    }
    onToken = (reqObj) => {
        this.props.showHideLoading(true);
        let headers = {
            'Content-Type': 'application/json'
        };
        postWithHeaders("/transactions/eventPurchaseThruOnline?access_token=", JSON.stringify(reqObj), headers).then((response) => {
            if (response.status === 200) {
                this.props.onPaymentDone(response);
            } else if (!response.ok) {
                this.props.onPaymentDone(response);
                //throw Error(response);
            }
            this.props.showHideLoading(false)
        }).catch(
            (error) => {
                this.props.showHideLoading(false);
                this.props.onPaymentDone({ status: null });
                console.log('Payment error:', error);
            }
        );
    }

    render() {
        const sid = this.props.schoolObject.schoolId || 0;

        const charges = ((getMurchantPayChargesStatus(sid)) ? 0 : (paymentGatewayOptions.UNIONPAY == getPaymentGateway(sid).payGatewayName || '') ? calculateUPayCharges(this.calculateFinalCharges(), false) :
            (paymentGatewayOptions.PAYMAYA == getPaymentGateway(sid).payGatewayName || '') ? calculatePayMayaCharges(this.calculateFinalCharges(), false) :
                (paymentGatewayOptions.STRIPE === getPaymentGateway(sid).payGatewayName || '') ? (getPaymentGatewayCharges(sid, this.calculateFinalCharges(), true)) : 0);

        return (<div class="panel panel-primary">
            <div class="panel-heading">
                <h3 class="panel-title"><i className="fa fa-shopping-cart"></i>{'Cart'}</h3>
            </div>
            <div class="panel-body">
                <div className="row">
                    <div className="col-md-12">
                        <div className="media-list">
                            {
                                Object.keys(this.props.checkOutData).length > 0 ?
                                    Object.keys(this.props.checkOutData).map((eventId, key) => {
                                        return (
                                            <div className="media">
                                                <div className="media-body">
                                                    <h5 className="media-heading color-1">{this.props.checkOutData[eventId].eventName}
                                                        <button onClick={(e) => {
                                                            this.props.onDeleteCartItem(eventId);
                                                        }} className="btn-facebook-link pull-right"><i class="fa fa-minus-circle" aria-hidden="true"></i></button></h5>
                                                    {
                                                        this.props.checkOutData[eventId].studentList.map((student, id) => {
                                                            return (
                                                                (student.amount || 0) > 0 ?
                                                                    <div className="media" style={{ marginLeft: '25px', marginTop: '5px' }}>
                                                                        <div className="media-body">
                                                                            <div className="row">
                                                                                <div className="col-md-8">
                                                                                    <span className="media-heading">{student.lastName + ', ' + student.firstName}</span>
                                                                                </div>
                                                                                <div className="col-md-4 text-right">
                                                                                    {'$ ' + convertTwoDecimalPoint(student.amount)}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div> : null
                                                            )
                                                        })
                                                    }
                                                    <div className="media" style={{ marginLeft: '25px', marginTop: '5px', borderTop: 'solid 1px #efdede' }}>
                                                        <div className="media-body">
                                                            <div className="row">
                                                                <div className="col-md-8">
                                                                    <span className="media-heading"><b>{'Total Amount :'}</b></span>
                                                                </div>
                                                                <div className="col-md-4 text-right">
                                                                    <b>{'$ ' + convertTwoDecimalPoint(this.calculateTotals(this.props.checkOutData[eventId].studentList))}</b>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>)
                                    }) :
                                    <div className="text-center" style={{ color: '#e4e4e4', fontSize: '13px' }}>--- Cart is empty ---</div>
                            }
                        </div>
                        <div className="media">
                            <div className="row">
                                <hr style={{ margin: '5px auto ' }} />
                                <div className="col-md-8">
                                    <span><b>Transaction Charges :</b></span>

                                </div>
                                <div className="col-md-4 text-right">
                                    <b>{'$ ' + convertTwoDecimalPoint(charges)}</b>
                                </div>

                            </div>
                            <div className="row">
                                <hr style={{ margin: '5px auto ' }} />
                                <div className="col-md-8">
                                    <span><b>Total Amount :</b></span>
                                </div>
                                <div className="col-md-4 text-right">
                                    <b>{'$ ' + convertTwoDecimalPoint(this.calculateFinalCharges() + charges)}</b>
                                </div>
                            </div>
                            <div className="row">
                                <hr style={{ margin: '5px auto ' }} />
                                <div className="col-md-12">
                                    {
                                        this.validatePayment() ?
                                            <PaymentModule
                                                paymentDesc={"EVENT_PAY"}
                                                schoolId={this.props.schoolObject.schoolId}
                                                schoolName={this.props.schoolObject.schoolName}
                                                userInfo={{
                                                    parent: getLoginParent()
                                                }}
                                                paymentObj={this.calculateTotalFee(this.props.checkOutData)}
                                                excludeCharges={getMurchantPayChargesStatus(this.props.schoolObject.schoolId || 0)}
                                                postDataForPayMaya={() => {
                                                    let requestObject = {
                                                        "transactionType": "Event",
                                                        "purchaseItemType": "Event",
                                                        "paymentType": "Online",
                                                        "transactionDescription": "Buy events",
                                                        "appFeeAmount": 0,//parseFloat(convertTwoDecimalPoint(calculateUPayCharges(this.state.payModalObject.totalTransactionAmount,false))),
                                                        "studentWiseTransactions": [],
                                                        "parentUserEmails": getLoginParent(),
                                                        "mealSchoolId": this.props.schoolObject.schoolId
                                                    };
                                                    let totalAmount = 0.00;
                                                    let studentWiseTransactions = [];
                                                    Object.keys(this.props.checkOutData).forEach(eventId => {
                                                        this.props.checkOutData[eventId].studentList.forEach(student => {
                                                            if (parseFloat(convertTwoDecimalPoint(student.amount)) > 0) {
                                                                totalAmount = totalAmount + parseFloat(convertTwoDecimalPoint(student.amount))
                                                                studentWiseTransactions.push({
                                                                    studentRecId: student.userId,
                                                                    transactionAmount: student.amount,
                                                                    eventInfo: {
                                                                        recId: eventId
                                                                    }
                                                                })
                                                            }
                                                        })
                                                    });
                                                    requestObject.studentWiseTransactions = studentWiseTransactions;
                                                    requestObject.totalTransactionAmount = totalAmount;
                                                    requestObject.transactionFees = getPaymentGatewayCharges(this.props.schoolObject.schoolId, parseFloat(totalAmount), false);
                                                    return requestObject;

                                                }}

                                                postDataForUnionPay={() => {
                                                    let requestObject = {
                                                        "transactionType": "Event",
                                                        "purchaseItemType": "Event",
                                                        "paymentType": "Online",
                                                        "paymentGateway": (paymentGatewayOptions.UNIONPAY === getPaymentGateway(this.props.schoolObject.schoolId).payGatewayName || '') ? "UnionPay" : "PayMaya",
                                                        "transactionDescription": "Buy events",
                                                        "studentWiseTransactions": [],
                                                        "parentUserEmails": getLoginParent(),
                                                        "mealSchoolId": this.props.schoolObject.schoolId
                                                    };
                                                    let totalAmount = 0.00;
                                                    let studentWiseTransactions = [];
                                                    Object.keys(this.props.checkOutData).forEach(eventId => {
                                                        this.props.checkOutData[eventId].studentList.forEach(student => {
                                                            if (parseFloat(convertTwoDecimalPoint(student.amount)) > 0) {
                                                                totalAmount = totalAmount + parseFloat(convertTwoDecimalPoint(student.amount))
                                                                studentWiseTransactions.push({
                                                                    studentRecId: student.userId,
                                                                    transactionAmount: student.amount,
                                                                    eventInfo: {
                                                                        recId: eventId
                                                                    }
                                                                })
                                                            }
                                                        })
                                                    });
                                                    requestObject.studentWiseTransactions = studentWiseTransactions;
                                                    requestObject.totalTransactionAmount = totalAmount;
                                                    requestObject.appFeeAmount = parseFloat(convertTwoDecimalPoint(calculateUPayCharges(parseFloat(totalAmount), false))),
                                                        requestObject.transactionFees = getPaymentGatewayCharges(this.props.schoolObject.schoolId, parseFloat(totalAmount), false);
                                                    return requestObject;

                                                }}
                                                onToken={(token) => {
                                                    let requestObject = {
                                                        "transactionType": "Event",
                                                        "purchaseItemType": "Event",
                                                        "paymentType": "Online",
                                                        "paymentGateway": (paymentGatewayOptions.UNIONPAY === getPaymentGateway(this.props.schoolObject.schoolId).payGatewayName || '') ? "UnionPay" : "PayMaya",
                                                        "transactionDescription": "Buy events",
                                                        "studentWiseTransactions": [],
                                                        "parentUserEmails": getLoginParent(),
                                                        "mealSchoolId": this.props.schoolObject.schoolId
                                                    };
                                                    let totalAmount = 0.00;
                                                    let studentWiseTransactions = [];
                                                    Object.keys(this.props.checkOutData).forEach(eventId => {
                                                        this.props.checkOutData[eventId].studentList.forEach(student => {
                                                            if (parseFloat(convertTwoDecimalPoint(student.amount)) > 0) {
                                                                totalAmount = totalAmount + parseFloat(convertTwoDecimalPoint(student.amount))
                                                                studentWiseTransactions.push({
                                                                    studentRecId: student.userId,
                                                                    transactionAmount: student.amount,
                                                                    eventInfo: {
                                                                        recId: eventId
                                                                    }
                                                                })
                                                            }
                                                        })
                                                    });
                                                    requestObject.studentWiseTransactions = studentWiseTransactions;
                                                    requestObject.totalTransactionAmount = totalAmount;
                                                    requestObject.appFeeAmount = stripeInfo(this.props.schoolObject.schoolId).application_free;
                                                    requestObject.transactionFees = getPaymentGatewayCharges(this.props.schoolObject.schoolId, parseFloat(totalAmount), false);

                                                    if (typeof (token) === 'string') {
                                                        requestObject["transactionToken"] = token;
                                                    }
                                                    else {
                                                        requestObject["transferId"] = token.transferId;
                                                        requestObject["chargeId"] = token.chargeId;
                                                    }
                                                    this.onToken(requestObject);
                                                }}
                                                //onPaymentDone={this.onPaymentDone} 
                                                showHideLoading={this.showHideLoading}
                                                onValidationError={(error) => {
                                                    _addNotificationError(error, this);
                                                }}
                                            />
                                            /*  <StripeEventCheckOut reqObject={this.props.checkOutData}
                                             schoolObject={this.props.schoolObject} 
                                             onPaymentDone={(res)=>{
                                                 this.props.onPaymentDone(res)
                                             }} 
                                             showHideLoading={(value)=>{
                                                 this.props.showHideLoading(value)
                                             }} 
                                             onValidationError={(error)=>{
                                                 //_addNotificationError(error,this);
                                             }} /> */

                                            :
                                            <button className="btn btn-success btn-sm btn-block">Pay With Card</button>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>)
    }
}
export default CheckoutList



// WEBPACK FOOTER //
// ./src/components/Parent/eventSlider/checkoutList.jsx